module.exports = __webpack_public_path__ + "static/media/batteryRedFilled.757364f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DevicesList/batteryRedFilled.svg
// module id = 829
// module chunks = 0